<template>
  <footer class="app-footer">
    <router-link class="app-footer-link" to="/termos">Termo de Uso</router-link>
    <span class="app-footer-sep">·</span>
    <router-link class="app-footer-link" to="/privacidade">Política de Privacidade</router-link>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppFooter'
})
</script>

<style scoped lang="scss">
.app-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 11.5px;
  color: var(--ink-faint, rgba(255, 255, 255, 0.4));
}

.app-footer-link {
  color: inherit;
  text-decoration: none;
  transition: color 0.15s ease;

  &:hover {
    color: var(--ink, #ffffff);
    text-decoration: underline;
  }
}

.app-footer-sep {
  opacity: 0.6;
}
</style>
